import { useEffect, useRef } from "react";
import { useTheme } from "emotion-theming";
import PropTypes from "prop-types";
import hexWithOpacity from "core-web/utils/hexWithOpacity";
import styled from "theme/libs/styled";
import CrossIcon from "theme/components/icons/CrossIcon";

const Wrapper = styled("div")`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: ${({ theme }) => hexWithOpacity(theme.colors.black, 20)};
    z-index: 99999;
    transition: all ${({ theme }) => theme.transitions.primaryFast};
    cursor: pointer;

    &[data-show="false"] {
        opacity: 0;
        pointer-events: none;
    }
`;

const Inner = styled("div")`
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -55%);
    background: ${({ theme }) => theme.colors.white};
    width: 90vw;
    height: auto;
    max-width: 595px;
    padding: 36px 24px;
    border-radius: 8px;
    transition: all ${({ theme }) => theme.transitions.primaryFast};
    cursor: default;

    &[data-show="true"] {
        transform: translate(-50%, -50%);
    }
`;

const CloseButton = styled(CrossIcon)`
    position: absolute;
    top: 18px;
    right: 24px;
    cursor: pointer;
`;

const Content = styled("div")``;

const ModalWrapper = ({ show, handleClose, children }) => {
    const { colors } = useTheme();
    const wrapperRef = useRef(null);

    // Close when clicking outside of modal window (black overlay).
    const handleOutsideClick = (e) => {
        if (wrapperRef.current && e.target === wrapperRef.current) {
            handleClose();
        }
    };

    useEffect(() => {
        document.addEventListener("click", handleOutsideClick);

        return () => {
            document.removeEventListener("click", handleOutsideClick);
        };
    }, []);

    return (
        <Wrapper data-show={show} ref={wrapperRef}>
            <Inner data-show={show}>
                <CloseButton width="24px" height="24px" color={colors.black} onClick={handleClose} />
                <Content>{children}</Content>
            </Inner>
        </Wrapper>
    );
};

ModalWrapper.propTypes = {
    show: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    children: PropTypes.element.isRequired,
};

export default ModalWrapper;
